import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Skeleton } from '@mui/material';

import MessageActions from '../message-actions/MessageActions';
import EditSection from './edit-section/EditSection';
import { changeAdjustedMessage } from '../../../../../redux/activ8/activ8MessagesReducer';

import scss from './MessageCard.module.scss';

function MessageCard({ message, isRedoing = false }) {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [draftPreview, setDraftPreview] = useState(message.preview ?? '');

  useEffect(() => {
    if (!isEditing) {
      setDraftPreview(message.preview ?? '');
    }
  }, [message.preview, isEditing]);

  const handleEditStart = () => {
    if (isRedoing) return;

    setDraftPreview(message.preview ?? '');
    setIsEditing(true);
  };

  const handleDiscard = () => {
    setDraftPreview(message.preview ?? '');
    setIsEditing(false);
  };

  const handleSave = () => {
    dispatch(
      changeAdjustedMessage({
        id: message.id,
        preview: draftPreview,
      }),
    );
    setIsEditing(false);
  };

  return (
    <div className={scss.wrapper}>
      <div className={scss.idCell}>{message.id}</div>

      <div className={scss.textContent}>
        {isEditing ? (
          <EditSection
            preview={draftPreview}
            onChange={setDraftPreview}
            onDiscard={handleDiscard}
            onSave={handleSave}
          />
        ) : isRedoing ? (
          <div className={scss.previewSkeleton}>
            <Skeleton variant='text' animation='wave' width='95%' />
            <Skeleton variant='text' animation='wave' width='88%' />
            <Skeleton variant='text' animation='wave' width='72%' />
            <Skeleton variant='text' animation='wave' width='60%' />
          </div>
        ) : (
          <div className={scss.preview}>{message.preview}</div>
        )}
      </div>

      <MessageActions id={message.id} onEdit={handleEditStart} isEditing={isEditing} isRedoing={isRedoing} />
    </div>
  );
}

export default MessageCard;
